export class HostedFieldsInstanceMissingError extends Error {
  constructor() {
    super('HostedFields instance is missing.');
    this.name = 'HostedFieldsInstanceMissingError';
  }
}
